import { IAgentSettings, IChangedSettings } from "../../types/agent-settings";
import {
  IAgentSettingsResponse,
  ITestCallResponse,
} from "../../types/api/agent-settings";
import { useApi } from "./api-service";
import {
  toBackendSettings,
  toFrontendSettings,
} from "../converters/agent-settings-converter";

export function useSettingsService() {
  const api = useApi();

  return {
    fetchSettings: async (): Promise<IAgentSettings> => {
      const settings = await api.get<IAgentSettingsResponse>("/");
      return toFrontendSettings(settings);
    },

    updateSettings: async (
      settings: IChangedSettings
    ): Promise<IAgentSettings> => {
      const updatedSettings = await api.patch<IAgentSettingsResponse>(
        "/",
        toBackendSettings(settings)
      );
      return toFrontendSettings(updatedSettings);
    },

    startTestCall: async (): Promise<ITestCallResponse> => {
      return api.post<ITestCallResponse>("/calls");
    },
  };
}
